import { PAGE_URLS } from '../../constants/hrefLinks'
import './style.scss'

function HeaderAppExplore() {

	const burgerButtonClickHandler = () => {
		// dispatch(toggleAppShowFilterMenu())
		window.location.replace(`${PAGE_URLS.APP_PROFILE}`)
	}

	return (
		<div className="header-app-explore-wrap">
			<div className="header-app-explore-wrap-inner">
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/instructor/icon-instructor-header-bell-button.svg'}
						className='header-app-header-button-img'
						alt='Bell Button'
					/>
				</div>
				<div className='header-app-header-button-wrap'>
					<img
						src={'/imgs/icons/explore/header-logo.svg'}
						className='header-app-header-button-img header-app-header-button-img-middle header-app-header-button-img-logo'
						alt='Lessons Text'
					/>
				</div>
				<div 
					className='header-app-header-button-wrap'
					onClick={() => {
						burgerButtonClickHandler()
					}}
				>
					<img
						src={'/imgs/icons/explore/icon-explore-burger-menu.svg'}
						className='header-app-header-button-burger'
						alt='Burger Menu'
					/>
				</div>
			</div>
		</div>
	)
}

export default HeaderAppExplore